import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  inject,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { addToFavorite, removeFromFavorite } from 'src/app/data/store/actions/shop.action';
import { selectCurrentPlatform } from 'src/app/data/store/selectors/platform.selectors';
import { selectCurrentUser } from 'src/app/data/store/selectors/users.selectors';
import {
  Buttons,
  ButtonTextSizes,
  CurrentPlatform,
  DepartmentsType,
  TextSizes,
  TextType,
} from '../../enums';
import { ITabsLinks } from '../../interfaces';
import { IUser } from '../../services/user/user.type';
import { selectLoadingStateOfShop } from 'src/app/data/store/selectors/shop.selectors';
import { IonPageContentComponent } from '../ion-page-container/ion-page-content/ion-page-content.component';
import { AsyncPipe } from '@angular/common';
import { ImageComponent } from '../image/image.component';
import { IonicModule } from '@ionic/angular';
import { InformationCardComponent } from './information-card/information-card.component';
import { ButtonComponent } from '../button/button.component';
import { BlockComponent } from '../block/block.component';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { TextComponent } from '../text/text.component';
import { AddBaseUrlPipe } from '../../pipe/add-baseUrl/add-base-url.pipe';
import { SetBillboardInfoPipe } from '../../pipe/set-billboard-info/set-billboard-info.pipe';
@Component({
  selector: 'app-billboard-page',
  templateUrl: './billboard-page.component.html',
  styleUrls: ['./billboard-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonPageContentComponent,
    ImageComponent,
    IonicModule,
    InformationCardComponent,
    ButtonComponent,
    BlockComponent,
    RouterLink,
    RouterLinkActive,
    TextComponent,
    RouterOutlet,
    AsyncPipe,
    AddBaseUrlPipe,
    SetBillboardInfoPipe,
  ],
})
export class BillboardPageComponent implements OnInit, OnDestroy {
  private readonly _store = inject(Store);

  @Input() billboardData: any;

  @Input() tabLinks: ITabsLinks[] = [];

  @Input() isNeedFavoriteLogic = false;

  @Input() isNeedCreatePhotoReportBtn = false;

  @Input() isShowNumOfEmployees = false;

  @Output() emitOpenModal: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('tabs') tabs?: ElementRef<HTMLDivElement>;

  public readonly TextSizes = TextSizes;

  public readonly TextType = TextType;

  public readonly Buttons = Buttons;

  public readonly ButtonTextSizes = ButtonTextSizes;

  public readonly CurrentPlatform = CurrentPlatform;

  readonly DepartmentsType = DepartmentsType;

  public platform$: Observable<CurrentPlatform | null> = this._store.select(selectCurrentPlatform);

  public readonly platform = CurrentPlatform;

  public currentUser$: Observable<IUser | null> = this._store.select(selectCurrentUser);

  public isFavStateLoading$ = this._store.select(selectLoadingStateOfShop);

  public keyboardIsOpen = false;

  ngOnInit(): void {
    this.platform$.subscribe(() => {
      this.keyboardIsOpen = true;
    });
  }

  ngOnDestroy(): void {
    this.keyboardIsOpen = false;
  }

  public getBilbordImage = () =>
    window.innerWidth < 769
      ? this.billboardData?.avatar?.previewLarge || '/assets/images/befree.png'
      : '/assets/images/shop-banner.png';

  public favoriteState(isShopFav: boolean, id: number) {
    if (!isShopFav) {
      this._store.dispatch(addToFavorite({ shopId: id }));
    } else this._store.dispatch(removeFromFavorite({ shopId: id }));
  }

  public emitCreatePhotoReportModal() {
    this.emitOpenModal.emit();
  }
}
